import { render, staticRenderFns } from "./Disbursed.vue?vue&type=template&id=94094660&scoped=true"
import script from "./Disbursed.vue?vue&type=script&lang=js"
export * from "./Disbursed.vue?vue&type=script&lang=js"
import style0 from "./Disbursed.vue?vue&type=style&index=0&id=94094660&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94094660",
  null
  
)

export default component.exports